module.exports = __webpack_public_path__ + "packs/media/images/das_matching_1-282c2bebb5d4380d9ba3d7aee78357f2.jpg";